import { Box, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';
import SimpleBreadCrumb from 'src/components/widgets/BreadCrumb/SimpleBreadCrumb';
import { EDR_COLORS } from './edrTokens';

type EdrPageHeaderProps = {
  breadcrumb: { links: Array<{ name: string; to: string }> };
  title: string;
  subtitle: string;
  actions?: ReactNode;
};

export const EdrPageHeader: FC<EdrPageHeaderProps> = ({
  breadcrumb,
  title,
  subtitle,
  actions,
}) => (
  <Box>
    <SimpleBreadCrumb data={breadcrumb} />
    <Box
      display="flex"
      alignItems="flex-start"
      justifyContent="space-between"
      flexWrap="wrap"
      style={{ gap: 12, marginTop: 8 }}
    >
      <Box minWidth={0}>
        <Typography
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: 22,
            fontWeight: 700,
            color: EDR_COLORS.textPrimary,
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: 14,
            color: EDR_COLORS.textSecondary,
            marginTop: 4,
          }}
        >
          {subtitle}
        </Typography>
      </Box>
      {actions ? (
        <Box display="flex" alignItems="center" style={{ gap: 8, flexShrink: 0 }}>
          {actions}
        </Box>
      ) : null}
    </Box>
  </Box>
);
